import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ProjectService } from 'src/app/_services/project.service';

@Component({
  selector: 'app-locator-screen',
  templateUrl: './locator-screen.component.html',
  styleUrls: ['./locator-screen.component.css']
})
export class LocatorScreenComponent implements OnInit {

  //DOM references down below
  @ViewChild("cancelUpdateScreen") cancelUpdateScreen: ElementRef;
  @ViewChild("cancelAddScreen") cancelAddScreen: ElementRef;
  
  //global variables down below
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Locator Screen',
    data: undefined,
  }
  projectId: string = "";
  locatorModuleId: string = "";
  pagesSize=beatBlipSubscriptionConsts.pagesSize;
  perpageitem =beatBlipSubscriptionConsts.perpageitem;
  projectData: any;
  locatorScreenData: any;
  locatorModuleName: any;
  selectedScreen: any;

  //Form groups below
  screenRenameForm: UntypedFormGroup;
  addLocatorScreenForm: UntypedFormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private projectService : ProjectService,
    private formBuilder: UntypedFormBuilder,
    private confirmationDialogService: ConfirmationDialogService,
    private toastrService: ToastrService
    ) { }

  ngOnInit() {
    this.initAllForms()
    this.activatedRoute.paramMap.subscribe((params)=>
    {
      this.projectId =  params.get("pid");
      this.locatorModuleId = params.get("mid");
      this.projectService.getProjectById(this.projectId).subscribe((res) => {
        this.headerOptions.data = {
          projectId: this.projectId,
          projectName: res["projectName"],
        };
        this.projectData = res;
        this.loadScreens();
      });
    })
  }

  initAllForms()
  {
    this.screenRenameForm = this.formBuilder.group({
      screenName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ]
    });

    this.addLocatorScreenForm = this.formBuilder.group({
      screenName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ]
    });
  }

  loadScreens()
  {
    this.projectService.getAllChildLocatorDir(this.projectId).subscribe((res) => {
      this.locatorScreenData = [];
      let locatorModuleData = res['locatorDirSuite'] ? res['locatorDirSuite'] : undefined;

      let suiteData = res["locatorSuite"]
        ? res["locatorSuite"].filter((data)=> data.parentLocatorId != undefined)
        : undefined;
      if (suiteData) {
        this.locatorScreenData = suiteData.filter((data) => data.parentLocatorId == this.locatorModuleId);
      }
      this.locatorModuleName = locatorModuleData.find((data)=> data.id == this.locatorModuleId).name;
      console.log(this.locatorModuleName, this.locatorScreenData);
    });
  }

  deleteScreen(screen)
  {
    this.confirmationDialogService
    .openConfirmDialog(
      "Are you sure you want to delete " + screen.name + " ?"
    )
    .afterClosed()
    .subscribe((res) => {
      if (res) {
        this.projectService
          .deleteLocator(this.projectId, screen.id)
          .subscribe((data) => {
            this.toastrService.clear();
            this.toastrService.success("screen deleted successfully");
            this.loadScreens();
          });
      }
    });
  }

  openUpdateScreen(screen) {
    this.selectedScreen = screen;
    console.log(screen);
    this.screenRenameForm.patchValue({
      screenName: screen.name
    });
  }

  updateLocatorScreen()
  {
    if (this.screenRenameForm.invalid) {
      return;
    }
    let formValue = this.screenRenameForm.value;
    console.log(this.screenRenameForm, formValue);
    let screen = {
      name: formValue.screenName,
      id: this.selectedScreen.id,
      projectId: this.projectId,
      parentLocatorId: this.locatorModuleId
    };

    if (!/^[^:|*?<>/\\"]+$/.test(formValue.screenName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Screen Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }
    this.projectService.editLocatorSuitTitle(screen).subscribe((data) => {
      this.toastrService.clear();
      this.toastrService.success("Screen updated succesfully");
      this.cancelUpdateScreen.nativeElement.click();
      this.loadScreens();
      this.initAllForms();
    });
  }

  addScreen() {
    if (this.addLocatorScreenForm.invalid) {
      return;
    }
    var formValue = this.addLocatorScreenForm.value;

    let ValueForAdd = { 
      name: formValue.screenName,
      parentLocatorId: this.locatorModuleId,
      projectId: this.projectId,
    };

    if (!/^[^:|*?<>/\"]+$/.test(formValue.screenName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Screen Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }

    this.projectService.addScreen(ValueForAdd).subscribe((data) => {
      if (data) {
        this.toastrService.clear();
        this.toastrService.success("Screen Added successfully");
        this.cancelAddScreen.nativeElement.click();
        this.loadScreens();
      }
    });

  }

}
